function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-697 -3050)",
  fill: "#fff"
}, React.createElement("circle", {
  cx: 699,
  cy: 3052,
  r: 2
})));

var SvgCarouselDot = function SvgCarouselDot(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 4 4"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/carousel_dot.6d090327.svg";
export { SvgCarouselDot as ReactComponent };